module.exports = __webpack_public_path__ + "static/img/img3.df4a538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img3.png
// module id = bf8A
// module chunks = 0